<h3>
  Documentação necessária
</h3>

<div class="text-center">
  <h5>
    Cliente
  </h5>
  <h4>
    <strong>{{cliente.nomeCliente || cliente.nome}}</strong>
  </h4>

  <div>
    <span>{{"Selecione e anexe os documentos abaixo"}} {{!utilizaDropComponent ? "(opcional)" : ""}} </span>
    <br/>
    <a (click)="openModalFotoDica()" class="text-primary">Veja aqui dicas para uma boa foto.</a>
  </div>
</div>

<hr class="fader up p-0 m-0" />

<div class="bg-gray" [class.pr30]="pr30" [class.pb30]="!pr30">
  <ul class="required-documents padding-inherit">
    <li *ngFor="let docto of documentosAnexar; index as i">
      <app-upload-documentation-item
        *ngIf="docto.idPendencia !== Documentation.Report"
        (fileChange)="handleFileChange($event, i)"
        [files]="normalizedFileList[i]"
        [filesDocuments]="normalizedFileList"
        [document]="docto"
        [documentIndex]="i"
        (removeFileCallback)="removeFile(i, $event)"
        (removeAllFilesCallback)="removeAllFiles(normalizedFileList, i)"
        [acceptFiles]="acceptFiles"
      ></app-upload-documentation-item>

      <app-report-documentation-item
        *ngIf="docto.idPendencia === Documentation.Report"
        [document]="docto"
        [proposalId]="idFicha"
        [reportCopy]="report"
        (changeReport)="handleChangeReport($event)"
      ></app-report-documentation-item>
      <hr class="gradient p-0 m-0" />

    </li>

  </ul>


  <div *ngIf="!hideInfo" class="text-center pt-5">
    <span class="text-primary">(máximo de 10 imagens por item)</span>
  </div>


  <div class="btn-select-all">
      <button  class="btn btn-border-orange fs-1-3" (click)="openModalSelecionarTodosDocumentos()">{{ buttonLabel || 'Selecionar mais de um documento' }}</button>
  </div>

  <section *ngIf="hasWarrantyPicturesDocument()">
    <h5 class="photos-title">Insira imagens do veículo:</h5>

    <ul class="photos list-unstyled">
      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 0)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 1)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>

      <li>
        <app-upload-foto-garantia (fileChange)="fileGarantiaChange($event, 2)" (errorSize)="isSizeLimit = true"></app-upload-foto-garantia>
      </li>
    </ul>
  </section>

  <div>
    <div *ngIf="isDocsObrigatorio" class="alert alert-danger alert-dismissable">
      <strong>Anexar todos os documentos solicitados antes do envio</strong>
    </div>

    <div *ngIf="isSizeLimit" class="alert alert-danger alert-dismissable">
      <strong>Tamanho do arquivo não permitido - Limite: 10 Mb</strong>
    </div>

    <div *ngIf="!hideInfo && mensagem" class="alert alert-info alert-dismissable">
      <span class="martinT10" *ngIf="isEnviandoDocumento">
        <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
      </span>

      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>

      <strong>{{ mensagem }}</strong>
    </div>
  </div>

  <hr class="fader down p-0" />

  <div class='btn-group-end justify-content-space-between'>
    <button class="btn btn-border-orange fs-1-3" (click)="onClose()">Voltar</button>
    <button class="btn btn-send send-doc martinT10 fs-1-3" [ngClass]="{ 'enabled': enableConfirmButton() }" (click)="confirmDocuments()">{{ buttonLabel || 'Confirmar seleção' }}</button>
  </div>

  <ng-content></ng-content>
</div>
